<template>
  <div v-if="versions.length" class="jv-versions">
    <div class="jv-versions-head">Versions</div>
    <div class="jv-versions-list">
      <div
        v-for="v in versions"
        :key="v.id"
        class="jv-version-item"
        :class="{ active: v.versionNumber === activeVersionNumber }"
        @click="$emit('select', v)"
      >
        <div class="jv-version-row">
          <span class="jv-version-badge">v{{ v.versionNumber }}</span>
          <span class="jv-version-time">{{ relativeTime(v.createdAt) }}</span>
        </div>
        <div class="jv-version-notes">{{ v.notes || 'No description provided.' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'journey-version-list',
  props: {
    versions: { type: Array, default: () => [] },
    activeVersionNumber: { type: Number, default: null }
  },
  methods: {
    relativeTime (ts) {
      const diffMs = Date.now() - ts
      const mins = Math.floor(diffMs / 60000)
      if (mins < 1) return 'just now'
      if (mins < 60) return `${mins}m ago`
      const hours = Math.floor(mins / 60)
      if (hours < 24) return `${hours}h ago`
      const days = Math.floor(hours / 24)
      return `${days}d ago`
    }
  }
}
</script>

<style scoped>
.jv-versions{margin-top:18px}
.jv-versions-head{font-size:11px;font-weight:600;color:var(--text-muted);text-transform:uppercase;letter-spacing:0.05em;margin-bottom:8px}
.jv-versions-list{display:flex;flex-direction:column;gap:6px}
.jv-version-item{padding:8px 10px;border-radius:8px;background:rgba(255,255,255,0.045);border:1px solid rgba(255,255,255,0.09);cursor:pointer;transition:background .12s,border-color .12s}
.jv-version-item:hover{background:rgba(255,255,255,0.08)}
.jv-version-item.active{background:rgba(20,184,166,0.16);border-color:rgba(20,184,166,0.45)}
.jv-version-row{display:flex;align-items:center;justify-content:space-between;gap:6px}
.jv-version-badge{font-family:'JetBrains Mono',monospace;font-size:11px;font-weight:700;color:var(--text)}
.jv-version-time{font-size:10.5px;color:var(--text-faint)}
.jv-version-notes{font-size:11px;color:var(--text-muted);margin-top:4px;line-height:1.4;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
</style>



// WEBPACK FOOTER //
// JourneyVersionList.vue?5ee87f74